import React from 'react';
import ObservationLogList from '../components/ObservationLogList';

const ObservationLogsPage = () => {
  return (
    <div style={{ padding: 16 }}>
      <ObservationLogList />
    </div>
  );
};

export default ObservationLogsPage;
